import Search from 'components/commons/search'
import { Button, Modal } from 'avo-ui'
import Select from 'components/commons/select'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import Table from 'components/commons/table'
import ModalExport from 'components/commons/modal-export'
import ModalConfirmation from 'components/commons/modal-confirmation'
import { TABLE_PARTNERSHIP } from 'configs/main-page/configTablePartnership'
import icX from 'assets/images/ic-x.svg'
import icLink from 'assets/images/ic-link.svg'

export const Partnership = ({
    dataList,
    modal,
    setShowModal,
    query,
    onChangeQuery,
    selectedIds,
    statusOptions,
    selectedStatus,
    attachments,
    onChangeStatus,
    onExport,
    onConfirm,
    onSelectItemHandler,
    onClickItemHandler,
    getUrl,
    isLoading,
    isUpdating,
    isExporting,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex space-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <Button
                        title={'Export'}
                        icon={icLinkExternal}
                        type={'outline'}
                        disabled={!dataList?.total_result}
                        onClick={() => setShowModal({ export: true })}
                    />
                </div>
                <div className={'flex space-x-3'}>
                    <Select
                        name={'status'}
                        className={'w-32'}
                        placeholder={'Select Status'}
                        options={statusOptions}
                        value={selectedStatus}
                        onChange={onChangeStatus}
                    />
                    <Button
                        title={'Apply'}
                        onClick={() => setShowModal({ confirm: true })}
                        disabled={!selectedIds?.length}
                    />
                </div>
            </div>
            <Table
                className={'my-3'}
                name={TABLE_PARTNERSHIP.name}
                columns={TABLE_PARTNERSHIP.column}
                data={dataList?.result}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onChangePage={(val) => onChangeQuery({ page: val })}
                onClickItem={(val) => onClickItemHandler(val)}
                loading={isLoading}
                isResetSelectedItem={query?.search}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={selectedIds?.length || dataList?.total_result}
                    isLoading={isExporting}
                    onExport={onExport}
                />
            )}
            {modal?.confirm && (
                <ModalConfirmation
                    show={modal?.confirm}
                    onHide={() => setShowModal({ confirm: false })}
                    description={`Are You Sure to Change Partnership Status to ${selectedStatus?.label}?`}
                    totalData={selectedIds?.length}
                    isLoading={isUpdating}
                    onConfirm={onConfirm}
                />
            )}
            {modal?.attachments && (
                <Modal
                    dialogClassName={'w-[330px]'}
                    contentClassName={'rounded-xl'}
                    show={modal?.attachments}
                    onHide={() => setShowModal({ attachments: false })}
                >
                    <div className={'flex flex-row px-6 py-5 items-center justify-between'}>
                        <div />
                        <p className={'font-bold text-blue-90 text-lg mt-2'}>Attachments</p>
                        <img
                            className={'w-5 -mt-8 cursor-pointer'}
                            src={icX}
                            alt='ic-x'
                            onClick={() => setShowModal({ attachments: false })}
                        />
                    </div>
                    <div className={'flex flex-col space-y-6 px-5 pb-5'}>
                        {Object.keys(attachments).map(
                            (key) =>
                                attachments?.[key]?.link && (
                                    <a
                                        href={getUrl(attachments?.[key]?.link)}
                                        target={'_blank'}
                                        className={'text-blue-90 hover:font-bold hover:underline'}
                                    >
                                        <div className={'flex items-center space-x-4'}>
                                            <img src={icLink} alt={'icon-link'} className={'w-5 h-5'} />
                                            <p>{attachments?.[key]?.label}</p>
                                        </div>
                                    </a>
                                ),
                        )}
                    </div>
                </Modal>
            )}
        </div>
    )
}
